<script setup lang="ts">
import type { SuggestionType } from '@apps/main/new-desktop/modules/suggestionTypeSelector';
import type { HotelFilter } from '@apps/main/new-desktop/modules/hotelFilters';
import { AccommodationSelector } from '@apps/main/new-desktop/modules/accommodationSelector';
import type { AccommodationSelectorType } from '@apps/main/new-desktop/modules/accommodationSelector';

import ItineraryTimeline from '../ItineraryTimeline.vue';
import type { UnavailableItineraryAccommodationSegment } from '../../../models';

import UnavailableAccommodationProduct from './UnavailableAccommodationProduct.vue';
import AccommodationSegmentHeader from './AccommodationSegmentHeader.vue';

interface UnavailableAccommodationSegmentProps {
  segment: UnavailableItineraryAccommodationSegment;
  // TODO: Calculate the message in store logic
  errorMessage: string;
}

const props = defineProps<UnavailableAccommodationSegmentProps>();

interface UnavailableAccommodationSegmentEmits {
  (eventName: 'add-filter'): void;
  (eventName: 'edit-filters'): void;
  (eventName: 'explore-other-products'): void;
  (eventName: 'remove-filter', id: HotelFilter): void;
  (eventName: 'show-more-filters'): void;
  (eventName: 'suggestion-type-selected', suggestionType: SuggestionType): void;
  (eventName: 'try-another-date'): void;
  (eventName: 'toggle-accommodation', value: AccommodationSelectorType): void;
}

const emit = defineEmits<UnavailableAccommodationSegmentEmits>();
</script>

<template>
  <ItineraryTimeline
    :segment-type="props.segment.segmentType"
    class="unavailable-accommodation-segment"
  >
    <template #dropdown>
      <AccommodationSelector
        selected-option="popularAccommodation"
        :disabled="false"
        class="accommodation-selector"
        :is-there-selected-accommodation="true"
        @toggle-accommodation="emit('toggle-accommodation', $event)"
      />
    </template>
    <template #header>
      <AccommodationSegmentHeader
        :segment="props.segment"
        :allow-no-accommodation="false"
        :print-mode="false"
        @suggestion-type-selected="emit('suggestion-type-selected', $event)"
        @add-filter="emit('add-filter')"
        @show-more-filters="emit('show-more-filters')"
        @remove-filter="emit('remove-filter', $event)"
      />
    </template>

    <template #content>
      <UnavailableAccommodationProduct
        :reasons="props.segment.reasons"
        :message="props.errorMessage"
        :ingredient-index="props.segment.context.ingredientIndex"
        @explore-other-products="emit('explore-other-products')"
        @edit-filters="emit('edit-filters')"
        @try-another-date="emit('try-another-date')"
      />
    </template>
  </ItineraryTimeline>
</template>
